'use client';

import { useEffect, useState } from 'react';

export const useHotspots = (hotspots) => {
  const [normalized, setNormalized] = useState([]);

  useEffect(() => {
    if (!hotspots?.length) return;
    const maxX = Math.max(...hotspots.map((h) => h.x));
    const maxY = Math.max(...hotspots.map((h) => h.y));

    const BUFFER = 300;

    const originalWidth = maxX + BUFFER;
    const originalHeight = maxY + BUFFER;

    const mapped = hotspots.map((spot) => ({
      ...spot,
      xPercent: (spot.x / originalWidth) * 100,
      yPercent: (spot.y / originalHeight) * 100,
    }));

    setNormalized(mapped);
  }, [hotspots]);

  return normalized;
};
